import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Clarity Icon (Activity Icon) from Figma: the sparkle on the Home | Clarity toggle
 * @link [Figma](https://www.figma.com/design/ARyRA98QKWA7iJ6jEuCY1l/Clarity?node-id=1008-101916)
 * */
const ClarityIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.75 11.25V10.5H9C8.79289 10.5 8.625 10.3321 8.625 10.125C8.625 9.91789 8.79289 9.75 9 9.75H9.75V9C9.75 8.79289 9.91789 8.625 10.125 8.625C10.3321 8.625 10.5 8.79289 10.5 9V9.75H11.25C11.4571 9.75 11.625 9.91789 11.625 10.125C11.625 10.3321 11.4571 10.5 11.25 10.5H10.5V11.25C10.5 11.4571 10.3321 11.625 10.125 11.625C9.91789 11.625 9.75 11.4571 9.75 11.25ZM5.61694 0.947754C5.76415 0.625846 6.23585 0.625849 6.38306 0.947754L6.40942 1.02173L7.3667 4.63257L10.9783 5.59058C11.3985 5.70202 11.3985 6.29798 10.9783 6.40942L7.3667 7.3667L6.40942 10.9783C6.29798 11.3985 5.70202 11.3985 5.59058 10.9783L4.63257 7.3667L1.02173 6.40942C0.601464 6.29798 0.601468 5.70202 1.02173 5.59058L4.63257 4.63257L5.59058 1.02173L5.61694 0.947754ZM5.30933 5.0083C5.27028 5.15528 5.15528 5.27028 5.0083 5.30933L2.40161 6L5.0083 6.69067C5.13691 6.72484 5.24088 6.81726 5.29102 6.93823L5.30933 6.9917L6 9.59766L6.69067 6.9917C6.72972 6.84472 6.84472 6.72972 6.9917 6.69067L9.59766 6L6.9917 5.30933C6.84472 5.27028 6.72972 5.15528 6.69067 5.0083L6 2.40161L5.30933 5.0083ZM1.5 3V2.25H0.75C0.542893 2.25 0.375 2.08211 0.375 1.875C0.375 1.66789 0.542893 1.5 0.75 1.5H1.5V0.75C1.5 0.542893 1.66789 0.375 1.875 0.375C2.08211 0.375 2.25 0.542893 2.25 0.75V1.5H3C3.20711 1.5 3.375 1.66789 3.375 1.875C3.375 2.08211 3.20711 2.25 3 2.25H2.25V3C2.25 3.20711 2.08211 3.375 1.875 3.375C1.66789 3.375 1.5 3.20711 1.5 3Z" className="fill-current" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ClarityIcon;